import {App, Platform} from 'ionic-angular';
import {CampaignServiceProvider} from '../../modules/ranking/services/campaign-service/campaign-service';
import {ConfigServiceProvider} from '../../modules/core/services/config-service/config-service';
import {ENVIRONMENT} from '../../../environments/environment';
import {FilterServiceProvider, FilterType} from '../../modules/core/services/filter-service/FilterServiceProvider';
import {Injectable} from '@angular/core';
import {RankingServiceProvider} from '../../modules/ranking/services/ranking-service/ranking-service';
import {StorageServiceProvider} from '../../modules/core/services/storage-service/storage-service';
import {AppLoadingServiceProvider} from "../../modules/core/services/app-loading-service/AppLoadingServiceProvider";
import {PlatformService} from "../../modules/core/services/platform-service/platform-service";

@Injectable()
export class LogoutService {
  constructor(
    private app: App,
    private campaignService: CampaignServiceProvider,
    private configService: ConfigServiceProvider,
    private filterService: FilterServiceProvider,
    private rankingService: RankingServiceProvider,
    private storageService: StorageServiceProvider,
    private appLoaded: AppLoadingServiceProvider,
    private platformService: PlatformService
  ) { }

  public logout() {
    let isMobile = this.platformService.isMobile();
    if (isMobile) {
      this.logoutFromMobileApp();
    } else {
      this.logoutFromWebApplication()
    }
  }

  private logoutFromMobileApp() {
    this.resetTokensAndFilters();
    this.app.getActiveNavs()[0]
      .push('LoginPage')
      .then(() => this.app.getRootNavs()[0].popToRoot())
      .catch(err => console.error(err));
  }

  private logoutFromWebApplication() {
    this.resetTokensAndFilters()
    window.location.href = this.configService.LOGOUT_URL + '?redirect_uri=' + ENVIRONMENT.authLoginRedirect + this.configService.APPLICATION_LOGIN;
  }

  private resetTokensAndFilters() {
    this.campaignService.resetPlayerCampaigns();
    this.storageService.set('accessToken', null);
    this.storageService.set('refreshToken', null);
    this.rankingService.setFilters(null);
    this.rankingService.setGroupFilters(null);
    this.rankingService.setHistoryFilters(null);
    this.filterService.setFilter(FilterType.CLIENTS, this.filterService.defaultFilter);
    this.filterService.setFilter(FilterType.CALENDAR, this.filterService.defaultFilter);
    this.storageService.flushCache();
    this.appLoaded.setStatus(false);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/logout.service.ts